// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import shallowCompare from 'react-addons-shallow-compare';

// -- tools
import ViewUtils from '../../utils/ViewUtils';
import classNames from 'classnames';

// -- views
import Dropzone from 'react-dropzone';
import SvgIcon from '../SvgIcon';

/**
 * Component that handle a single pdf file drop.
 */
export default class PdfDropzone extends Component {

  static defaultProps = {
    className: '',

    readOnly: false,

    file: null
  };

  static propTypes = {
    className: PropTypes.string,

    /*
     * @param String (data base64) The cropped image
     * @param String (data base64) The full size image
     */
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool,

    /**
     * The current selected file
     */
    file: PropTypes.object
  };

  shouldComponentUpdate(nextProps, newState) {
    return shallowCompare(this, nextProps, newState);
  }

  onDelete = () => {
    this.props.onChange(null);
  };

  onDrop = (files) => {
    if (this.props.readOnly) {
      return;
    }

    const file = files[0];
    const filesize = file.size;

    if (filesize >= this.props.maxSize) {
      // TODO: check the filesize.
    }

    this.props.onChange(file);
  };


  //
  //  renderers
  //

  renderReadOnly() {
    return (
      <div className="pdf_dropzone disabled">
        <SvgIcon
          icon={SvgIcon.UPLOAD}
        />
      </div>
    );
  }

  render() {
    if (this.props.readOnly) {
      return this.renderReadOnly();
    }
    return (
      <div className="pdf_dropzone">
        <Dropzone
          onDrop={this.onDrop}
          multiple={false}
          accept="application/pdf"
          className="dropzone"
        >
          <SvgIcon
            icon={SvgIcon.UPLOAD}
          />
        </Dropzone>
        { !_.isNull(this.props.file) &&
          <span>
            "{this.props.file.name}"
            <i
              className="fa fa-trash pdf_dropzone__delete"
              onClick={this.onDelete}
            />
          </span>
        }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/PdfDropzone.js